import {
  Box,
  IconButton,
  Typography,
  Stack,
  Avatar,
  TextField,
  Divider,
  Button,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import CowIcon from "../CowIcon";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const NewLoanView: React.FC<{ isMobile: boolean; onBack: () => void }> = ({
  isMobile,
  onBack,
}) => {
  const theme = useTheme();
  const [photo, setPhoto] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    tagNumber: "",
    breed: "",
    age: "",
    estimatedValue: "",
    healthStatus: "",
    location: "",
    loanAmount: "",
    loanTerm: "6",
  });

  const handlePhotoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target?.result) {
          setPhoto(event.target.result as string);
        }
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Submit to blockchain
    console.log({ photo, ...formData });
  };

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <IconButton onClick={onBack}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" sx={{ ml: 1 }}>
          New Cattle Loan
        </Typography>
      </Box>

      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          {/* Photo Upload */}
          <Box sx={{ textAlign: "center" }}>
            <label htmlFor="cattle-photo">
              <Avatar
                sx={{
                  width: 120,
                  height: 120,
                  margin: "0 auto",
                  bgcolor: photo ? "transparent" : "grey.200",
                  cursor: "pointer",
                }}
              >
                {photo ? (
                  <img
                    src={photo}
                    alt="Cattle"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <CowIcon size={48} fill={theme.palette.text.secondary} />
                )}
              </Avatar>
              <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                {photo ? "Change photo" : "Upload cattle photo"}
              </Typography>
              <input
                id="cattle-photo"
                type="file"
                accept="image/*"
                capture="environment"
                onChange={handlePhotoUpload}
                style={{ display: "none" }}
              />
            </label>
          </Box>

          {/* Cattle Details */}
          <TextField
            label="Tag Number"
            name="tagNumber"
            value={formData.tagNumber}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            label="Breed"
            name="breed"
            value={formData.breed}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            label="Age (years)"
            name="age"
            type="number"
            value={formData.age}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            label="Estimated Value (AGD)"
            name="estimatedValue"
            type="number"
            value={formData.estimatedValue}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            label="Health Status"
            name="healthStatus"
            value={formData.healthStatus}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            label="Location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            fullWidth
          />

          {/* Loan Details */}
          <Divider sx={{ my: 1 }} />

          <TextField
            label="Loan Amount (AGD)"
            name="loanAmount"
            type="number"
            value={formData.loanAmount}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            label="Loan Term (months)"
            name="loanTerm"
            select
            value={formData.loanTerm}
            onChange={handleChange}
            fullWidth
            SelectProps={{
              native: true,
            }}
          >
            {[3, 6, 9, 12].map((term) => (
              <option key={term} value={term}>
                {term} months
              </option>
            ))}
          </TextField>

          <Box sx={{ mt: 2 }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              size="large"
            >
              Submit Loan Request
            </Button>
          </Box>
        </Stack>
      </form>
    </Box>
  );
};

export default NewLoanView;
